import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { toast } from 'react-toastify';
import { labRequestEssay } from '../../../helpers/adipiBackendUrl';
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";
import {
  ADD_NEW_LABREQUESTESSAY,
  DELETE_LABREQUESTESSAY,
  GET_LABREQUESTESSAYS,
  UPDATE_LABREQUESTESSAY
} from "./actionTypes";
import {
  addLabRequestEssayFail,
  addLabRequestEssaySuccess,
  deleteLabRequestEssayFail,
  deleteLabRequestEssaySuccess,
  getLabRequestEssaysFail,
  getLabRequestEssaysSuccess,
  setState,
  updateLabRequestEssayFail,
  updateLabRequestEssaySuccess,
} from "./actions";
//Include Both Helper File with needed methods

function* fetchLabRequestEssays( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable, labRequestEssay, params.toString());
    yield put(setState(false))
    yield put(getLabRequestEssaysSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getLabRequestEssaysFail(error));
  }
}

function* updateLabRequestEssay ({payload: labRequestEssayObj }) {
  try {
    const { id, recordStatus, ...rest } = labRequestEssayObj;
    yield call(patchApiCall, `${labRequestEssay}/${id}`, rest);
    const response = yield call(getTable,`${labRequestEssay}/${labRequestEssayObj.id}`);
    yield put(updateLabRequestEssaySuccess(response));
    toast.success('Registro actualizado correctamente')
  } catch (error) {
    yield put(updateLabRequestEssayFail(error));
    toast.error('Error al actualizar el registro')
  }
}


function* deleteLabRequestEssay ({payload: labRequestEssayObj}) {
  try {
    yield call(deleteApiCall,`${labRequestEssay}/${labRequestEssayObj.id}` );
    yield put(deleteLabRequestEssaySuccess(labRequestEssayObj.id));
    toast.success('Registro borrado correctamente')
  } catch (error) {
    yield put(deleteLabRequestEssayFail(error));
    toast.error('Error al borrar el registro')
  }
}

function* postingLabRequestEssay ({ payload: labRequestEssayObj}) {
  try {
    yield put(setState(true))
    const response = yield call(postApiCall, labRequestEssay ,labRequestEssayObj);
    const response1 = yield call(getTable,`${labRequestEssay}/${response.id}`);
    yield put(addLabRequestEssaySuccess(response1));
    yield put(setState(false))
    toast.success('Registro agregado correctamente')
  } catch (error) {
    yield put(setState(false))
    yield put(addLabRequestEssayFail(error));
    toast.error('Error al agregar el registro')
  }
}

function* labRequestEssaysSaga() {
  yield takeEvery(GET_LABREQUESTESSAYS, fetchLabRequestEssays);
  yield takeEvery(ADD_NEW_LABREQUESTESSAY, postingLabRequestEssay);
  yield takeEvery(UPDATE_LABREQUESTESSAY, updateLabRequestEssay);
  yield takeEvery(DELETE_LABREQUESTESSAY, deleteLabRequestEssay);
}

export default labRequestEssaysSaga;
